import { observer } from 'mobx-react';
import React from 'react';
import Text, { TEXT } from 'src/view/components/Text/Text';
import './style.scss';

interface IProps {
  title: string;
  onPress?: () => void;
  is_active: boolean;
}

const UserRolesListItem: React.FC<IProps> = observer((props: IProps): JSX.Element => {
  return (
    <div
      className={`mb-2 full-width d-flex align-items-center cursor-pointer justify-content-between user-roles-list__list-item ${
        props.is_active ? 'active' : ''
      }`}
      onClick={props.onPress}>
      <Text type={TEXT.CUSTOM} text={props.title} className="user-roles-list__list-item-title" />
    </div>
  );
});

export default UserRolesListItem;
